import {Card, CardType, GemType, ItemType} from './card';

export const CARDS: Card[][] = [[
	{
		id: 0,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'A Fine Hat',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'Crystal Ball',
		itemImg:  '',
		itemText: 'Add another tile',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 1,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Hiking Boots',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'Tarot Deck',
		itemImg:  '',
		itemText: 'Add another tile',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 2,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Fashionable Vest',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'Obsidian Mirror',
		itemImg:  '',
		itemText: 'Add another tile',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 3,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Fragrant Herbs',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Expensive Sneakers',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 4,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Padded Jacket',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Déjà Vu',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 5,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Vial of Quicksilver',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Compass',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 6,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Parchment and Quill',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.draw,
		itemName: 'Canary',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 7,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Paring Knife',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.draw,
		itemName: 'Trained Gecko',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 8,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Inspirational Quotes',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.draw,
		itemName: 'Motion Detector',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 9,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Bag of Breadcrumbs',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.xp,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '+1 Experience<span> when trading in cards</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 5,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 10,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Glowing Pebble',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.xp,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '+1 Experience<span> when trading in cards</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 5,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 11,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Leather Gloves',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.xp,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '+1 Experience<span> when trading in cards</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 5,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 12,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Pocket Calculator',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Band-Aid',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 13,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Plastic Bat',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Gauze',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 14,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Flashlight',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Tree Bark',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 15,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Ball of Twine',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Rollerblades',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 16,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Slingshot',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Toboggan',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 17,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Pocket Knife',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Energy Drink',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 18,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Chalk',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 19,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Hardtack',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 20,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Pictures from Home',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 21,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Earrings',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 22,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Boxing Gloves',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 23,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Towel',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 24,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Textbook',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  0
	},
	{
		id: 25,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Gardening Gloves',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  0
	},
	{
		id: 26,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Flint and Steel',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  0
	},
	{
		id: 27,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Glasses',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  0
	},
	{
		id: 28,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Can of Spinach',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 1, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  0
	},
	{
		id: 29,
		level: 0,
		cardType:  CardType.starter,
		cardName: 'Harmonica',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  0
	}
	], [
	{
		id: 1000,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Anaconda',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 1, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Regurgitated Meal',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1001,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Angry Gibbon',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Crude Spear',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1002,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Baboon',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 2, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Stone Knife',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1003,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Badger',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1004,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Bats',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 1, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Fast Food',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1005,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Boar',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Bacon!',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.enBravado,
		rightGem:  1
	},
	{
		id: 1006,
		level: 1,
		cardType:  CardType.event,
		cardName: 'Brief Reprieve',
		cardImg:  '',
		cardText: 'Heal a wound',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 1,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 1007,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Carefully Laid Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Cheese!',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 1008,
		level: 1,
		cardType:  CardType.event,
		cardName: 'Cave-In',
		cardImg:  '',
		cardText: 'Remove a tile',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 2,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 1009,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Cave Octopus',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 1, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'A Very Fancy Hat',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1010,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Centipedes',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'That creepy crawly feeling all over…',
		itemImg:  '',
		itemText: 'Add an extra tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1011,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Chickcharney',
		cardImg:  '',
		cardText: 'Owl monster of the Bahamas',
		cardStats: { Brains: 4, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Magic Feather',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1012,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Coconut Crab',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.enBrawn,
		rightGem:  1
	},
	{
		id: 1013,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Collapsing Wall',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: null, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'Open Passage',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1014,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Cougar',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsTraps,
		rightGem:  2
	},
	{
		id: 1015,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Crocodile',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 5, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Tough Hide',
		itemImg:  '',
		itemText: 'Discard an Enemy before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 13,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1016,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Cunning Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Carrots!',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 1017,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Dart Frog',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 1, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Poison Dart',
		itemImg:  '',
		itemText: 'Reduce an Enemy’s Brawn by 3',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 21,
		itemValue: -3,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1018,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Dart Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: null, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Spring Mechanism',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1019,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Debris Pile',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Runestone',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1020,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Dense Smoke',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'Guttering Torch',
		itemImg:  '',
		itemText: 'Add an extra tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1021,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Drop Bear',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 3, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'Where did that come from?',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1022,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Falling Rocks',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 2, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Big, pointy rock',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1023,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Falling Sand',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: null, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Fulgurite',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1024,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Fire Ants',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 1, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'A great source of protein',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	// {
	// 	id: 1025,
	// 	level: 1,
	// 	cardType:  CardType.event,
	// 	cardName: 'Flash Flood',
	// 	cardImg:  '',
	// 	cardText: 'The player on your right moves your character one space',
	// 	cardStats: { Brains: null, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.none,
	// 	itemName: '',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: null, Brawn: null, Bravado: null },
	// 	itemPower: 0,
	// 	leftGem:   null,
	// 	rightGem:  null
	// },
	{
		id: 1026,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Gnomes',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 1, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Alchemical Elixir',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1027,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Hibernating Grizzly',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 5, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Bear Pelt',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1028,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Hyenas',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsEnemies,
		rightGem:  2
	},
	// {
	// 	id: 1029,
	// 	level: 1,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Imp',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 4, Brawn: 1, Bravado: 1 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'Brimstone',
	// 	itemImg:  '',
	// 	itemText: 'Shuffle a trap back into its deck<br>Draw a new card',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Bravado,
	// 	rightGem:  1
	// },
	{
		id: 1030,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Jackalope',
		cardImg:  '',
		cardText: 'Ferocious antlered rabbit of North America',
		cardStats: { Brains: 3, Brawn: 2, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Antlers',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1031,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Kangaroo',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 3, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1032,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'King Cobra',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Cobra Fangs',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1033,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Komodo Dragon',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 4, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.postCombat,
		itemName: 'Scale Armor',
		itemImg:  '',
		itemText: 'Force an Enemy to reroll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 12,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1034,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Koolakamba',
		cardImg:  '',
		cardText: 'Legendary African ape',
		cardStats: { Brains: 1, Brawn: 4, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Surprisingly detailed schematics',
		itemImg:  '',
		itemText: '+3 vs one trap',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 18,
		itemValue: 3,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1035,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Kumi Lizard',
		cardImg:  '',
		cardText: 'Giant tree lizard of New Zealand',
		cardStats: { Brains: 2, Brawn: 1, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Forked Tongue',
		itemImg:  '',
		itemText: 'Reduce an Enemy’s Bravado by 3',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 22,
		itemValue: -3,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1036,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Lightning Sand',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 2, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Sand in your shoes',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1037,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Menehune',
		cardImg:  '',
		cardText: 'Tiny builders and tricksters of Hawaii',
		cardStats: { Brains: 5, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Enchanted Hammer',
		itemImg:  '',
		itemText: 'Discard a Trap before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 14,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1038,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Moles',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'A convenient hole',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 1039,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Mongoose',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.enBrains,
		rightGem:  1
	},
	{
		id: 1040,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Mothman',
		cardImg:  '',
		cardText: 'Bird-man of West Virginia',
		cardStats: { Brains: 2, Brawn: 4, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'Tattered Wings',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1041,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Mountain Fennec',
		cardImg:  '',
		cardText: 'Legendary fox of the Sahara',
		cardStats: { Brains: 2, Brawn: 3, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Foxtail',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1042,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Mountain Goat',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 3, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'Impossible Passage',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1043,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Musk Deer',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 1, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Fangs',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  0
	},
	{
		id: 1044,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Onza',
		cardImg:  '',
		cardText: 'Legendary South American jaguar',
		cardStats: { Brains: 1, Brawn: 3, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1045,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Oubliette',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Discarded Rope',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	// {
	// 	id: 1046,
	// 	level: 1,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Panther',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 1, Brawn: 3, Bravado: 3 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'Black Fur',
	// 	itemImg:  '',
	// 	itemText: 'Shuffle an enemy back into its pile<br>Draw a new card',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brains,
	// 	rightGem:  -1
	// },
	{
		id: 1047,
		level: 1,
		cardType:  CardType.event,
		cardName: 'The path grows clearer',
		cardImg:  '',
		cardText: 'Add a tile',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 3,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 1048,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Pit Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Bullwhip',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1049,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Puma',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  -2
	},
	{
		id: 1050,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Python',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1051,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Rattlesnake',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.postCombat,
		itemName: 'Rattle',
		itemImg:  '',
		itemText: 'Reduce an Enemy’s die roll by 2',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 23,
		itemValue: -2,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1052,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Rats',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'A less-than-satisfying meal',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 1053,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Razor Wire',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 1, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Cat o’ Nine Tails',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  1
	},
	{
		id: 1054,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Recluse Spider',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Add a tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1055,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Rolling Boulder',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Memory of your truly epic escape',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1056,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Scattered Pebbles',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Small glowing stone',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  0
	},
	{
		id: 1057,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Scorpions',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 1, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Anti-Venom',
		itemImg:  '',
		itemText: 'Heal one wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	// {
	// 	id: 1058,
	// 	level: 1,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Skunk',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 1, Brawn: 1, Bravado: 4 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'Scent Gland',
	// 	itemImg:  '',
	// 	itemText: 'Shuffle an enemy back into its deck<br>Draw a new card',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brawn,
	// 	rightGem:  1
	// },
	{
		id: 1059,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Slab of Rock',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 2, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Lots of dust and rubble',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1060,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Spear Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: null, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Silvered Spear Tip',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1061,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Spike Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 2, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Dismantled Trigger',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1062,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Squirrels',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 2, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Pointy Stick',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	// {
	// 	id: 1063,
	// 	level: 1,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Tasmanian Devil',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 4, Brawn: 2, Bravado: 1 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useNow,
	// 	itemName: 'Centripetal Force',
	// 	itemImg:  '',
	// 	itemText: 'Rotate one tile',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Bravado,
	// 	rightGem:  1
	// },
	{
		id: 1064,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Tiger',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 4, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Tiger Claw',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	// {
	// 	id: 1065,
	// 	level: 1,
	// 	cardType:  CardType.trap,
	// 	cardName: 'Tripwire Maze',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 2, Brawn: 1, Bravado: 1 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'Lariat',
	// 	itemImg:  '',
	// 	itemText: 'Shuffle an enemy back into its deck<br>Draw a new card',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.vsTraps,
	// 	rightGem:  -1
	// },
	{
		id: 1066,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Wandering Spider',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 1, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Crunch',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 1067,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Wasps',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.tile,
		itemName: 'Teeny Tiny Wings',
		itemImg:  '',
		itemText: 'Add an extra tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	// {
	// 	id: 1068,
	// 	level: 1,
	// 	cardType:  CardType.trap,
	// 	cardName: 'Water-filled Pit',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 1, Brawn: 1, Bravado: 2 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'Clear Lens',
	// 	itemImg:  '',
	// 	itemText: 'Shuffle a trap back into its deck<br>Draw a new card',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.vsEnemies,
	// 	rightGem:  -1
	// },
	{
		id: 1069,
		level: 1,
		cardType:  CardType.trap,
		cardName: 'Whirling Blades',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.draw,
		itemName: 'Glittering Sickle',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1070,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Wolf',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 4, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Learn to Howl',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1071,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Wolpertinger',
		cardImg:  '',
		cardText: 'German chimera',
		cardStats: { Brains: 1, Brawn: 3, Bravado: 2 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 1072,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Young Bear',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 4, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'Bear Claw',
		itemImg:  '',
		itemText: '+3 vs one Enemy',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 17,
		itemValue: 3,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 1073,
		level: 1,
		cardType:  CardType.enemy,
		cardName: 'Zombie',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 1, Brawn: 1, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Rags',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	}
	], [
	{
		id: 2001,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Agogwe',
		cardImg:  '',
		cardText: 'Legendary<br>African Ape',
		cardStats: { Brains: 4, Brawn: 4, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2002,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Angry Mushrooms',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 4, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Cloud of Spores',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 2003,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Banshee',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2004,
		level: 2,
		cardType:  CardType.event,
		cardName: 'Brief Reprieve',
		cardImg:  '',
		cardText: 'Heal a wound',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 1,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  0
	},
	{
		id: 2005,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Bunyip',
		cardImg:  '',
		cardText: 'Australian swamp monster',
		cardStats: { Brains: null, Brawn: 4, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2006,
		level: 2,
		cardType:  CardType.event,
		cardName: 'Cave-In',
		cardImg:  '',
		cardText: 'Remove a tile',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 2,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  0
	},
	{
		id: 2007,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Chuchunya',
		cardImg:  '',
		cardText: 'Russian sasquatch',
		cardStats: { Brains: 4, Brawn: 5, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Increase your <b>Brawn</b> by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 9,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 2008,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Chupacabra',
		cardImg:  '',
		cardText: 'American dog-lizard',
		cardStats: { Brains: null, Brawn: 3, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 2009,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Crushing Walls',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 2010,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Faun',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.postCombat,
		itemName: 'Pan Flute',
		itemImg:  '',
		itemText: 'Force an Enemy to reroll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 12,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2011,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Fire Ants',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Eternal Flame',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 2012,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Fire Pit',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Everlasting Torch',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  -1
	},
	{
		id: 2013,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Ghoul',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 4, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2014,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Giant Sloth',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 4, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Sense of <u>Wrong</u>ness',
		itemImg:  '',
		itemText: 'Reduce each Enemy’s Bravado by 2',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 22,
		itemValue: -2,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  3
	},
	{
		id: 2015,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Giant Spider Web',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Silk Armor',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2016,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Gibbon Ambush Party',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 6, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2017,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Gibbon Patrol',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 3, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNext,
		itemName: 'Alarum',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 2018,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Gibbon Scout',
		cardImg:  '',
		cardText: 'Australian swamp monster',
		cardStats: { Brains: 4, Brawn: 3, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Crude Map',
		itemImg:  '',
		itemText: 'Add an extra tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  1
	},
	{
		id: 2019,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Gnoll',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 4, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2020,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Goblin',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2021,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Kobold',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Candle',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsTraps,
		rightGem:  1
	},
	{
		id: 2022,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Kongamato',
		cardImg:  '',
		cardText: 'African pterosaur',
		cardStats: { Brains: null, Brawn: 4, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  2
	},
	{
		id: 2023,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Kung-Fu Tortoise',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 4, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Increase your <b>Bravado</b> by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 10,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 2024,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Land Shark',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 5, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Sharkskin Crampons',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -2
	},
	{
		id: 2025,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Lava Bear',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 4, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2026,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Locked Chest',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Cursed Treasure',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: -2, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2027,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Lugat',
		cardImg:  '',
		cardText: 'Albanian vampire',
		cardStats: { Brains: 5, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move 2 extra spaces',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 2,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2028,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Mapinguari',
		cardImg:  '',
		cardText: 'South American sloth-ape',
		cardStats: { Brains: null, Brawn: 4, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2029,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Momo',
		cardImg:  '',
		cardText: 'Missouri sasquatch',
		cardStats: { Brains: 5, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2030,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Nephilim',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 4, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  3
	},
	{
		id: 2031,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Ogre',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 5, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2032,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Olitiau',
		cardImg:  '',
		cardText: 'African giant bat',
		cardStats: { Brains: 5, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2033,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Orang-bati',
		cardImg:  '',
		cardText: 'Indonesian flying monkey',
		cardStats: { Brains: 4, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2034,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Orang Pendek',
		cardImg:  '',
		cardText: 'Sumatran ape-man',
		cardStats: { Brains: 5, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2035,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Ozark Howler',
		cardImg:  '',
		cardText: 'North American antlered bear',
		cardStats: { Brains: null, Brawn: 4, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 2036,
		level: 2,
		cardType:  CardType.event,
		cardName: 'The path grows clearer',
		cardImg:  '',
		cardText: 'Add a tile',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 3,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 2037,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Pogeyan',
		cardImg:  '',
		cardText: 'Legendary black tiger of India',
		cardStats: { Brains: null, Brawn: 5, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2038,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Poukai',
		cardImg:  '',
		cardText: 'Maori giant eagle',
		cardStats: { Brains: 4, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Golden Feather',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: null, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2039,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Radioactive Moles',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 4, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNext,
		itemName: 'A Glowing Hole',
		itemImg:  '',
		itemText: 'Move to any adjacent or diagonal tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2040,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Rat King',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 4, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Discard an Enemy before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 13,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2041,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Redcap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'A Red Cap',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2042,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Revenant',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 4, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  -1
	},
	{
		id: 2043,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Salamander',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 2, Brawn: 4, Bravado: 1 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Burning Branch',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.enemyRoll,
		rightGem:  -2
	},
	{
		id: 2044,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Sasquatch',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 5, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	{
		id: 2045,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Sigbin',
		cardImg:  '',
		cardText: 'Goat-like vampire of the Philippines',
		cardStats: { Brains: 4, Brawn: null, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Blood loss',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: -1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsEnemies,
		rightGem:  2
	},
	{
		id: 2046,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Skunk Ape',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 3, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2047,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Small Giant',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 4, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn * GemType.Bravado,
		rightGem:  1
	},
	{
		id: 2048,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Stollenwurm',
		cardImg:  '',
		cardText: 'Swiss tunnel dragon',
		cardStats: { Brains: 4, Brawn: null, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Tunnel Through the Wall',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 2049,
		level: 2,
		cardType:  CardType.event,
		cardName: 'Surge of Power',
		cardImg:  '',
		cardText: 'Roll a die<ul><li>1–2: gain a wound</li><li>3–4: nothing happens</li><li>5–6: heal a wound</li></ul>',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 4,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 2050,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Tatzelwurm',
		cardImg:  '',
		cardText: 'Cat-faced giant lizard of Austria',
		cardStats: { Brains: 4, Brawn: null, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Deep Burrow',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 2051,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Tsuchinoko',
		cardImg:  '',
		cardText: 'Intelligent Japanese flying snake',
		cardStats: { Brains: 5, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2052,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Urayuli',
		cardImg:  '',
		cardText: 'Alaskan yeti',
		cardStats: { Brains: 5, Brawn: 3, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2053,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Waheela',
		cardImg:  '',
		cardText: 'Canadian dog-bear',
		cardStats: { Brains: 4, Brawn: 4, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 2054,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Wall of Flame',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Cleansing Fire',
		itemImg:  '',
		itemText: 'Heal a wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  1
	},
	{
		id: 2055,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Warg',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 4, Brawn: 5, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsTraps,
		rightGem:  2
	},
	{
		id: 2056,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Well-Hidden Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 3, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Heal two wounds',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 2,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  1
	},
	{
		id: 2057,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Well-Placed Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 3, Bravado: 3 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'A Protein-Rich Snack',
		itemImg:  '',
		itemText: 'Heal a wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.vsEnemies,
		rightGem:  2
	},
	{
		id: 2058,
		level: 2,
		cardType:  CardType.trap,
		cardName: 'Will o’ the Wisp',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Unexplored Pathways',
		itemImg:  '',
		itemText: 'Add 2 tiles',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 2,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  1
	},
	{
		id: 2059,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Yateveo',
		cardImg:  '',
		cardText: 'Murderous African tree',
		cardStats: { Brains: null, Brawn: 3, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Questionable Fruit',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 2060,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Yeren',
		cardImg:  '',
		cardText: 'Chinese ape-man',
		cardStats: { Brains: 4, Brawn: 3, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useNext * ItemType.move,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  2
	},
	{
		id: 2061,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Yeti',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 3, Brawn: 5, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Increase your <b>Brains</b> by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 8,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.vsEnemies,
		rightGem:  3
	},
	{
		id: 2062,
		level: 2,
		cardType:  CardType.enemy,
		cardName: 'Yowie',
		cardImg:  '',
		cardText: 'Legendary Australian ape',
		cardStats: { Brains: 5, Brawn: 3, Bravado: 4 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	}
	], [
	{
		id: 3001,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Acid Spray',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 7, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNext,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Draw an extra card<span>, then discard one</span>',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 2,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3002,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Asanbosam',
		cardImg:  '',
		cardText: 'Asante vampire',
		cardStats: { Brains: 7, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3003,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Baobhan Sith',
		cardImg:  '',
		cardText: 'Scottish vampire',
		cardStats: { Brains: 6, Brawn: 6, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.enBravado,
		rightGem:  1
	},
	{
		id: 3004,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Basilisk',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 6, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Discard an Enemy before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 13,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  1
	},
	{
		id: 3005,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Bladed Pendulums',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 8, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Large, Light Blade',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3006,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Bluecap',
		cardImg:  '',
		cardText: 'English mine ghost',
		cardStats: { Brains: 6, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Spectral Luminescence',
		itemImg:  '',
		itemText: 'Add a tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 3,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3007,
		level: 3,
		cardType:  CardType.event,
		cardName: 'Brief Reprieve',
		cardImg:  '',
		cardText: 'Heal a wound',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 1,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 3008,
		level: 3,
		cardType:  CardType.event,
		cardName: 'Cave-In',
		cardImg:  '',
		cardText: 'Remove a tile',
		cardStats: { Brains: null, Brawn: null, Bravado: null },
		cardPower: 2,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	},
	{
		id: 3009,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Cerberus',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 7, Brawn: 7, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 2, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -2
	},
	{
		id: 3010,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Chimera',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 7, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3011,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Cockatrice',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 6, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Increase your <b>Bravado</b> by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 10,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.enBrains,
		rightGem:  -1
	},
	{
		id: 3012,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Dingonek',
		cardImg:  '',
		cardText: 'Giant sabre-toothed pangolin of Kenya',
		cardStats: { Brains: null, Brawn: 7, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.vsEnemies,
		rightGem:  2
	},
	// {
	// 	id: 3013,
	// 	level: 3,
	// 	cardType:  CardType.event,
	// 	cardName: 'A Distant Rumbling',
	// 	cardImg:  '',
	// 	cardText: 'Rotate a tile',
	// 	cardStats: { Brains: null, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.none,
	// 	itemName: '',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: null, Brawn: null, Bravado: null },
	// 	itemPower: 0,
	// 	leftGem:   null,
	// 	rightGem:  null
	// },
	// {
	// 	id: 3014,
	// 	level: 3,
	// 	cardType:  CardType.trap,
	// 	cardName: 'Distorted Gravity',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 8, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useNow,
	// 	itemName: 'TBD',
	// 	itemImg:  '',
	// 	itemText: 'Remove a tile<br>Draw a tile',
	// 	itemStats: { Brains: null, Brawn: null, Bravado: null },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brawn * GemType.Bravado,
	// 	rightGem:  2
	// },
	{
		id: 3015,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Dokkaebi',
		cardImg:  '',
		cardText: 'Japanese goblins',
		cardStats: { Brains: 6, Brawn: 6, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Discard a Trap before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 14,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  3
	},
	// {
	// 	id: 3016,
	// 	level: 3,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Doppelgänger',
	// 	cardImg:  '',
	// 	cardText: 'Uses the current <b>Bravado</b> of the player to your right',
	// 	cardStats: { Brains: null, Brawn: null, Bravado: 0 },
	// 	cardPower: 0,
	// 	itemType:  ItemType.permanent,
	// 	itemName: 'TBD',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
	// 	itemPower: 0,
	// 	itemValue: 0,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Bravado,
	// 	rightGem:  3
	// },
	// {
	// 	id: 3017,
	// 	level: 3,
	// 	cardType:  CardType.event,
	// 	cardName: 'Earthquake',
	// 	cardImg:  '',
	// 	cardText: '−1 to your next die roll',
	// 	cardStats: { Brains: null, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.none,
	// 	itemName: '',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: null, Brawn: null, Bravado: null },
	// 	itemPower: 0,
	// 	leftGem:   null,
	// 	rightGem:  null
	// },
	// {
	// 	id: 3018,
	// 	level: 3,
	// 	cardType:  CardType.trap,
	// 	cardName: 'Electrified Floor',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: null, Brawn: 7, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useOnce * ItemType.preCombat,
	// 	itemName: 'TBD',
	// 	itemImg:  '',
	// 	itemText: 'Prevent an Enemy from rolling a die',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 1,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brains * GemType.Bravado,
	// 	rightGem:  2
	// },
	{
		id: 3019,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Firebird',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 7, Brawn: null, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3020,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Griffin',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 3021,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Hellhound',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 7, Brawn: 7, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 2, Brawn: 2, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -2
	},
	{
		id: 3022,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Hibagon',
		cardImg:  '',
		cardText: 'Japanese sasquatch',
		cardStats: { Brains: 6, Brawn: null, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3023,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Illusionary Floor',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  2
	},
	{
		id: 3024,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Impenetrable Darkness',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Echolocation',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -1
	},
	{
		id: 3025,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Insidious Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 5, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'Free Gift',
		itemImg:  '',
		itemText: 'Increase your lowest attribute by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 11,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  2
	},
	{
		id: 3026,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'J’ba Fofi',
		cardImg:  '',
		cardText: 'Giant spider of the Congo',
		cardStats: { Brains: null, Brawn: 5, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.postCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Discard an Enemy after you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 13,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -2
	},
	{
		id: 3027,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Krasue',
		cardImg:  '',
		cardText: 'Disembodied vampiric head of SE Asia',
		cardStats: { Brains: 5, Brawn: null, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.postCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Discard a Trap after you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 14,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.enBravado,
		rightGem:  -1
	},
	{
		id: 3028,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Living Shadow',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: null, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Defeat a Trap before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 16,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  -1
	},
	{
		id: 3029,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Loose Stalactites',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 7, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.preCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Defeat a Trap before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 16,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3030,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Ponaturi',
		cardImg:  '',
		cardText: 'Māori goblins',
		cardStats: { Brains: 7, Brawn: null, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.discAny * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Heal a wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 3031,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Mahamba',
		cardImg:  '',
		cardText: 'Giant crocodile of the Congo',
		cardStats: { Brains: null, Brawn: 7, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Armored Hide',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  3
	},
	{
		id: 3032,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Masterful Trap',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 5, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.useOnce * ItemType.anytime,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Increase your lowest attribute by 1',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 11,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.enemyRoll,
		rightGem:  2
	},
	// {
	// 	id: 3033,
	// 	level: 3,
	// 	cardType:  CardType.trap,
	// 	cardName: 'Maze of Mirrors',
	// 	cardImg:  '',
	// 	cardText: '',
	// 	cardStats: { Brains: 7, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.useNow,
	// 	itemName: 'See Around Corners',
	// 	itemImg:  '',
	// 	itemText: 'Draw two tiles<br>Place one and discard the other',
	// 	itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 2,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brawn * GemType.Bravado,
	// 	rightGem:  2
	// },
	{
		id: 3034,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Megaconda',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 6, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 2, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains,
		rightGem:  2
	},
	// {
	// 	id: 3035,
	// 	level: 3,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Mimic',
	// 	cardImg:  '',
	// 	cardText: 'Uses the current <b>Brawn</b> of the player to your right',
	// 	cardStats: { Brains: null, Brawn: 0, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.permanent,
	// 	itemName: 'TBD',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 0,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brawn,
	// 	rightGem:  3
	// },
	{
		id: 3036,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Minhocão',
		cardImg:  '',
		cardText: 'South American giant serpent',
		cardStats: { Brains: 7, Brawn: 6, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 1, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3037,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Mngwa',
		cardImg:  '',
		cardText: 'Giant black lion of Tanzania',
		cardStats: { Brains: null, Brawn: 7, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  3
	},
	{
		id: 3038,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Mongolian Death Worm',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 7, Brawn: 7, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3039,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Namahage',
		cardImg:  '',
		cardText: 'Japanese ogre',
		cardStats: { Brains: 7, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 3 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  3
	},
	{
		id: 3040,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Nandi Bear',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 8, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  3
	},
	{
		id: 3041,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Nightstalker',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: 8, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.discTwo * ItemType.preCombat,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Defeat an Enemy before you roll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 15,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.none,
		rightGem:  0
	},
	{
		id: 3042,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Ōmukade',
		cardImg:  '',
		cardText: 'Giant Japanese centipede',
		cardStats: { Brains: 5, Brawn: null, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  3
	},
	{
		id: 3043,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Oni',
		cardImg:  '',
		cardText: 'Japanese troll',
		cardStats: { Brains: 7, Brawn: 7, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3044,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Peluda',
		cardImg:  '',
		cardText: 'Giant venomous porcupine of France',
		cardStats: { Brains: null, Brawn: 6, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 2 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  3
	},
	{
		id: 3045,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Pukwudgie',
		cardImg:  '',
		cardText: 'Native American goblin',
		cardStats: { Brains: 6, Brawn: null, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '+1 to all rolls',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 19,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brawn,
		rightGem:  1
	},
	{
		id: 3046,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Quantum Moles',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 9, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce,
		itemName: 'Portable Hole',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  3
	},
	{
		id: 3047,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Rolling Boulder',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: 8, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useNext,
		itemName: 'Hole Smashed in Wall',
		itemImg:  '',
		itemText: 'Move to any adjacent tile',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 6,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3048,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Rope Bridge',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 1, Brawn: 1, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  2
	},
	// {
	// 	id: 3049,
	// 	level: 3,
	// 	cardType:  CardType.enemy,
	// 	cardName: 'Satori',
	// 	cardImg:  '',
	// 	cardText: 'Uses the current <b>Brains</b> of the player to your right',
	// 	cardStats: { Brains: 0, Brawn: null, Bravado: null },
	// 	cardPower: 0,
	// 	itemType:  ItemType.permanent,
	// 	itemName: 'TBD',
	// 	itemImg:  '',
	// 	itemText: '',
	// 	itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
	// 	itemPower: 0,
	// 	itemValue: 0,
	// 	itemUsed:  false,
	// 	leftGem:   GemType.Brains,
	// 	rightGem:  3
	// },
	{
		id: 3050,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Shunka Warakin',
		cardImg:  '',
		cardText: 'South American dire wolf',
		cardStats: { Brains: null, Brawn: 5, Bravado: 8 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 1 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn * GemType.Bravado,
		rightGem:  1
	},
	{
		id: 3051,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Sirrush',
		cardImg:  '',
		cardText: 'Ancient Babylonian hydra',
		cardStats: { Brains: 6, Brawn: 6, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  1
	},
	{
		id: 3052,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Slimy, Glowing Pit',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: null, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Luminous Moss',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3053,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Snallygaster',
		cardImg:  '',
		cardText: 'Giant bird-lizard of Maryland',
		cardStats: { Brains: 6, Brawn: 7, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brawn * GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3054,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Sphinx',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.allRolls,
		rightGem:  3
	},
	{
		id: 3055,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Surma',
		cardImg:  '',
		cardText: 'Finnish devil-dog',
		cardStats: { Brains: 6, Brawn: 6, Bravado: 6 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn * GemType.Bravado,
		rightGem:  1
	},
	{
		id: 3056,
		level: 3,
		cardType:  CardType.trap,
		cardName: 'Swarm of Bugs',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: null, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.useNow,
		itemName: 'Yum',
		itemImg:  '',
		itemText: 'Heal a wound',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 1,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn,
		rightGem:  2
	},
	{
		id: 3057,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Troll',
		cardImg:  '',
		cardText: 'English',
		cardStats: { Brains: null, Brawn: 8, Bravado: 5 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'Petrified Club',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 3, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.enBrains,
		rightGem:  3
	},
	{
		id: 3058,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Vampire',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 8, Brawn: 5, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.useOnce,
		itemName: 'Mesmerism',
		itemImg:  '',
		itemText: 'Force an Enemy to reroll',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 12,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.Bravado,
		rightGem:  2
	},
	{
		id: 3059,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Vilkati',
		cardImg:  '',
		cardText: 'Latvian werewolf',
		cardStats: { Brains: 7, Brawn: 6, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: 'Move an extra space',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 4,
		itemValue: 1,
		itemUsed:  false,
		leftGem:   GemType.trapRoll,
		rightGem:  3
	},
	{
		id: 3060,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Vrykolakas',
		cardImg:  '',
		cardText: 'Greek undead',
		cardStats: { Brains: 6, Brawn: null, Bravado: 7 },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3061,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Wendigo',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 8, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.Brains * GemType.Brawn * GemType.Bravado,
		rightGem:  3
	},
	{
		id: 3062,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Werewolf',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 5, Brawn: 8, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: 3, Brawn: 0, Bravado: 0 },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   GemType.enBrawn,
		rightGem:  3
	},
	{
		id: 3063,
		level: 3,
		cardType:  CardType.enemy,
		cardName: 'Wyvern',
		cardImg:  '',
		cardText: '',
		cardStats: { Brains: 6, Brawn: 7, Bravado: null },
		cardPower: 0,
		itemType:  ItemType.permanent,
		itemName: 'TBD',
		itemImg:  '',
		itemText: '+2 to all rolls vs Traps',
		itemStats: { Brains: 0, Brawn: 0, Bravado: 0 },
		itemPower: 18,
		itemValue: 2,
		itemUsed:  false,
		leftGem:   GemType.enBrawn,
		rightGem:  1
	}
],
[
	{
		id: 4001,
		level: 4,
		cardType:  CardType.heart,
		cardName: 'Dragon',
		cardImg:  '',
		cardText: 'In the heart of the mountain, a mighty dragon waits in its lair<br><br><br>Counts as both an Enemy and a Trap',
		cardStats: { Brains: 10, Brawn: 10, Bravado: 10 },
		cardPower: 0,
		itemType:  ItemType.none,
		itemName: '',
		itemImg:  '',
		itemText: '',
		itemStats: { Brains: null, Brawn: null, Bravado: null },
		itemPower: 0,
		itemValue: 0,
		itemUsed:  false,
		leftGem:   null,
		rightGem:  null
	}
]];
